class ChristmasCalendar extends HTMLElement {
  connectedCallback() {
    this.elements = {
      countdown: this.querySelector('[data-christmas-calendar-countdown]'),
      dayAll: this.querySelectorAll('[data-christmas-calendar-day]')
    };

    this.sectionData = JSON.parse(this.getAttribute('data-section-data') || '{}');

    this.dateNow = new Date();
    
    this.days = this.sectionData.blocks
      .filter((block) => block.type == 'day')
      .map((day) => {
        var isDateEligible = this.getDayDateEligibleState(day);

        return { ...day, isDateEligible };
      });

    this.days = this.days
      .map((day) => {
        var isDateExpired = this.getDayDateExpiredState(day);

        return { ...day, isDateExpired };
      });

    this.isDaysAllDateEligible = this.days.every((day) => day.isDateEligible);

    this.elements.dayAll.forEach((dayElement) => {
      var dayElementData = JSON.parse(dayElement.getAttribute('data-christmas-calendar-day') || '{}');

      var day = this.days.find((day) => day.id == dayElementData.id);

      if (day.isDateEligible) {
        dayElement.classList.add('is-date-eligible');
      }

      if (day.isDateExpired) {
        dayElement.classList.add('is-date-expired');
      }
    });

    var dayNext = this.getDayNext();
    
    this.elements.countdown.innerHTML = `
      <ua-countdown-timer
        id="christmas-countdown-timer"
        data-end-date="${dayNext.settings.date_start}"
        data-hide-expired-digits="true"
        data-show-leading-zero="true"
        data-hide-labels="false"
        data-countdown-id="christmas-countdown-timer"
      >
        <clock>
          <days data-title="${window.countdownStrings.days}"></days>
          <hours data-title="${window.countdownStrings.hours}"></hours>
          <minutes data-title="${window.countdownStrings.minutes}"></minutes>
          <seconds data-title="${window.countdownStrings.seconds}"></seconds>
        </clock>
      </ua-countdown-timer>
    `;

    if (!this.isDaysAllDateEligible) {
      setInterval(() => {
        var dateNow = new Date();

        var dayNext = this.getDayNext();

        var dayNextDateStart = new Date(dayNext.settings.date_start);

        if (dateNow >= dayNextDateStart) {
          location.href = location.href;
        }
      }, 1000);
    }

    window.addEventListener('christmas-calendar-drawer-button:click', (event) => {
      this.elements.dayAll.forEach((dayElement) => {
        if (dayElement.classList.contains('is-date-eligible')) {
          dayElement.classList.add('is-date-expired');
        }
      });
    });
  }

  getDayNext() {
    var dayNext = this.days.slice(-1)[0];

    for (const day of this.days) {
      var isDateEligible = this.getDayDateEligibleState(day);

      if (!isDateEligible) {
        dayNext = day;
        break;
      }
    }

    return dayNext;
  }

  getDayDateEligibleState(day) {
    var dayDateStart = new Date(day.settings.date_start);

    return this.dateNow > dayDateStart;
  }

  getDayDateExpiredState(day) {
    var dayIndex = this.days.findIndex((day_) => day_.id == day.id);

    var isDateExpired = false;

    this.days.forEach((day_, index) => {
      if (index <= dayIndex) return;

      if (day_.isDateEligible) {
        isDateExpired = true;
      }
    });

    return isDateExpired;
  }
}

customElements.define("christmas-calendar", ChristmasCalendar);
